// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-preview__wrapper .image-preview[data-v-bddb7ebe]{padding:10px;border-radius:5px;-o-object-fit:contain;object-fit:contain;max-height:500px;max-width:500px;-webkit-transition:-webkit-box-shadow .2s;transition:-webkit-box-shadow .2s;transition:box-shadow .2s;transition:box-shadow .2s,-webkit-box-shadow .2s}.image-preview__wrapper .image-preview[data-v-bddb7ebe]:hover{-webkit-box-shadow:0 10px 20px 0 rgba(0,0,0,.3);box-shadow:0 10px 20px 0 rgba(0,0,0,.3)}", ""]);
// Exports
module.exports = exports;
